export const levels = [
  { key: 'all', text: 'All Levels', value: 'All Levels' },
  {
    key: 'absolute-beginner',
    text: 'Absolute Beginner',
    value: 'Absolute Beginner',
  },
  { key: 'lower-beginner', text: 'Lower Beginner', value: 'Lower Beginner' },
  { key: 'upper-beginner', text: 'Upper Beginner', value: 'Upper Beginner' },
  {
    key: 'lower-intermediate',
    text: 'Lower Intermediate',
    value: 'Lower Intermediate',
  },
  {
    key: 'upper-intermediate',
    text: 'Upper Intermediate',
    value: 'Upper Intermediate',
  },
  { key: 'advanced', text: 'Advanced', value: 'Advanced' },
];
